import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles, useMediaQuery } from '@ellucian/react-design-system/core';
import { useTheme } from '@mui/material';
import { routes } from '../Helpers/Configuration';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@ellucian/react-design-system/core';
import { Link } from 'react-router-dom';
const useStyles = makeStyles({
    name: 'invalidApplicantLink'
})(() => ({
    root: {
        textAlign: 'center',
        marginBottom: '4rem'
    },
}));
const desktopImage = 'https://cdn.elluciancloud.com/assets/EDS2/4.0.0/img/illustrations/large/403.png';
const mobileImage = 'https://cdn.elluciancloud.com/assets/EDS2/4.0.0/img/illustrations/large/403Narrow.png';
const Illustration = () => {
    const intl = useIntl();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const imgSrc = useMemo(() => isMobile ? mobileImage : desktopImage, [isMobile]);
    return <img alt={intl.formatMessage({ id: 'invalidApplicantLinkImgAlt' })} src={imgSrc} />;
};
const IllustrationWrapper = Illustration;

const InvalidApplicantLink = () => {
    const { classes } = useStyles();
    return (
        <div className={classes.root}>
            <IllustrationWrapper />
            <Typography variant="h1">
                <FormattedMessage id="invalidApplicantLinkHeader" />
            </Typography>
            <Typography variant="h3">
                <Link to={routes.retrieval}>
                    <FormattedMessage id="invalidApplicantLinkSubheader" />
                </Link>
            </Typography>
        </div>
    );
};

export default InvalidApplicantLink;
